/**
 * Every route path in one place. Never hardcode a route string in a component;
 * a typo in a link is invisible until someone clicks it.
 */
export const ROUTES = {
  login: "/login",
  authCallback: "/auth/callback",
  // Opened by Teams in its sign-in popup; see docs/TEAMS.md.
  teamsSignInStart: "/auth/teams-start",
  teamsSignInEnd: "/auth/teams-end",
  staff: "/staff",
  department: (departmentId: string) => `/staff/departments/${departmentId}`,
  document: (departmentId: string, documentId: string) =>
    `/staff/departments/${departmentId}/documents/${documentId}`,
  activity: (activityId: string) => `/staff/activities/${activityId}`,
  guide: "/staff/guide",
  adminUsers: "/staff/admin/users",
  adminContent: "/staff/admin/content",
} as const;

export const ROUTE_PATTERNS = {
  department: "/staff/departments/:departmentId",
  document: "/staff/departments/:departmentId/documents/:documentId",
  activity: "/staff/activities/:activityId",
  guide: "/staff/guide/*",
} as const;
